import Typography from '@mui/material/Typography';
import Icon from '@mdi/react';
import SvgIcon from '@mui/material/SvgIcon';
import { ElementType, FC } from 'react';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

type TCalendarToolbarIcon = {
  viewOption: {
    buttonText?: string,
    icon: string | ElementType,
    isSvg: boolean
  }
};

const CalendarToolbarIcon: FC<TCalendarToolbarIcon> = ({ viewOption }) => {
  const { t } = useTranslation('schedule');
  const theme = useTheme();

  if (viewOption.buttonText) {
    return (
      <div className="align-center justify-space-between">
        <Icon
          color={theme.palette.primary.main}
          path={viewOption?.icon as string}
          size={0.8}
        />
        <Typography ml={1} variant="body2" color="primary">{t(`${viewOption.buttonText}`)}</Typography>
      </div>
    );
  }
  return (
    viewOption.isSvg ? (
      <SvgIcon
        component={viewOption?.icon as ElementType}
        inheritViewBox
        fontSize="small"
      />
    )
      : (
        <Icon
          color={theme.palette.primary.main}
          path={viewOption?.icon as string}
          size={0.8}
        />
      )
  );
};

export {
  CalendarToolbarIcon,
};
